import {useEffect, useRef, useState} from 'react';
import { useNavigate, useSearchParams } from "react-router-dom";
/*import Suggestions from './components/Suggestions.js';*/
import {AddressAutoComplete} from '../../components/AddressAutoComplete.jsx';
import {CreditCard} from './components/CreditCard.js';
/*import "./common.css";*/
import "./signup.css";

export const SignUp = () => {
  const navigate = useNavigate();
  const [updateCode, setUpdateCode] = useState('');
  const [searchParams, setSearchParams] = useSearchParams();
  const [token, setToken] = useState('');
  const [values, setValues] = useState({});
  const [errors, setErrors] = useState({});
  const [errorMessage, setErrorMessage] = useState('');
  const [creditCodeError, setCreditCodeError] = useState('');
  const [creditCodeSuccess, setCreditCodeSuccess] = useState('');
  const [creditCodeClasses, setCreditCodeClasses] = useState(['sectionHidden']); // approvalCreditRow', 'sectionHidden']);
  const [downArrowClass, setDownArrowClass] = useState('referralCodeArrow');
  const [addressText, setAddressText] = useState('');
  //const [directionPressed, setDirectionPressed] = useState('');
  const [autocompleteFocused, setAutocompleteFocused] = useState(false);
  const [suggestions, setSuggestions] = useState({result: []});
  const [suggestionIndex, setSuggestionIndex] = useState(-1);
  const [autocompleteExpanded, setAutocompleteExpanded] = useState(false);
  const [addressSectionClasses, setAddressSectionClasses] = useState(["approvalInfoSection"]);
  const [creditSectionClasses, setCreditSectionClasses] = useState(["approvalInfoSection", "sectionHidden"]);
  const address1Ref = useRef();

  const handleChange = (event) => {
    setValues(inputs => ({...inputs, [event.target.name]: event.target.value}));
  };

  const referralDownClick = () => {
    if (downArrowClass == 'referralCodeArrow') {
        // show the code input
        setDownArrowClass('referralCodeArrowUp');
        setCreditCodeClasses(['']);
    } else {
        // hide it
        setDownArrowClass('referralCodeArrow');
        setCreditCodeClasses(['sectionHidden']);
    }
  };

  const onSubmit = (event) => {
    event.preventDefault();
  };

  const nextClick = () => {
    setErrors({});
    let canContinue = true;
    if (!values.first_name) {
        setErrors(current => ({...current, first_name: 'You must enter a first name'}));
        canContinue = false;
    }
    if (!values.last_name) {
        setErrors(current => ({...current, last_name: 'You must enter a last name'}));
        canContinue = false;
    }
    if (!values.address1) {
        setErrors(current => ({...current, address1: 'You must enter an address'}));
        canContinue = false;
    }
    if (!values.city) {
        setErrors(current => ({...current, city: 'You must enter a city'}));
        canContinue = false;
    }
    if (!values.zipcode) {
        setErrors(current => ({...current, zipcode: 'You must enter a zipcode'}));
        canContinue = false;
    }
    if (!values.state) {
        setErrors(current => ({...current, state: 'You must enter a state'}));
        canContinue = false;
    }

    if (!canContinue) {
        return;
    }
    setAddressSectionClasses(['approvalInfoSection', 'sectionHidden']);
    setCreditSectionClasses(['approvalInfoSection']);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const returnToInformation = () => {
    setAddressSectionClasses(['approvalInfoSection']);
    setCreditSectionClasses(['approvalInfoSection', 'sectionHidden']);
  }
/*
  const address1KeyUp = (event) => {
    if (event.key === "ArrowDown") {
        console.log('down arrow');
        setAutocompleteFocused(true);
        setSuggestionIndex(index => index + 1);
    }
    //setAddressText(event.target.value);
  };

  const address1OnBlur = (event) => {
    setAddressText('');
  };
*/
  const setAddress = (address1, city, state, zipcode, address2) => {
    console.log(values);
    setValues(current => ({...current, 
      address1: address1,
      city: city,
      state: state,
      zipcode: zipcode,
      address2: address2
    }));
  }

  const setAutocompleteVisible = (isVisible) => {
    console.log('autocomplete visible');
    console.log(isVisible);
    setAutocompleteExpanded(isVisible);
  };

  const getAddressSuggestions = async (search, selected) => {
    await fetch('https://us-autocomplete-pro.api.smartystreets.com/lookup?auth-id=103673942335523758&search=' + search + '&selected=' + (selected ? selected : ''),
      {
        headers: {"Content-Type": "application/json"},
      }
    ).then(response => {
      response.json().then(data => { setSuggestions({result: data.suggestions});} );
    });
  };

  const selectSuggestion = (address, suggestion) => {
    let selected = address.replace(" more entries", "");
    selected = selected.replace(",", "");

    if (suggestion.entries && suggestion.entries > 1) {
        // this has a sub menu
        getAddressSuggestions(suggestion.street_line, selected); 
    } else {
        // select it
        values.address1 = suggestion.street_line;
        values.city = suggestion.city;
        values.state = suggestion.state;
        values.zipcode = suggestion.zipcode;
        setSuggestions({result: []});
    }
  }
/*
  const address1KeyUp = (event) => {
    getAddressSuggestions(event.target.value);
  };
*/
/*
  const address1OnBlur = (event) => {
    setSuggestions({result: []});
  };
*/
  useEffect(() => {
    document.title = 'Fellow Drops - Signup';
    if (!window.document.getElementById('stripe-script')) {
      var s = window.document.createElement("script");
      s.id = "stripe-script";
      s.type = "text/javascript";
      s.src = "https://js.stripe.com/v3/";
      s.onload = () => {
        const style = {
          base: {
            // Add your base input styles here. For example:
            fontSize: '14px',
            color: '#32325d',
            '::placeholder': {
              color: '#999999'
            },
            border: '2px solid black',
          },
        };
        const expiryStyle = {
          base: {
            // Add your base input styles here. For example:
            fontSize: '14px',
            '::placeholder': {
                color: '#999999'
            },
          }
        };

        window.stripeObj = window['Stripe'](`${process.env.REACT_APP_STRIPE_KEY}`);
        window.elements = window.stripeObj.elements();
        window.cardNumber = window.elements.create('cardNumber', {
            style: style,
            placeholder: 'Card number'
        });
        window.cardNumber.mount('#cardNumber');

        window.cardExpiry = window.elements.create('cardExpiry', {
           style: expiryStyle,
           placeholder: 'Expiration date (MM/YY)'
        });
        window.cardExpiry.mount('#expirationDate');

        window.cardCvc = window.elements.create('cardCvc', {
            style: expiryStyle,
            placeholder: 'Security code'
        });
        window.cardCvc.mount('#securityCode');

      }
      window.document.body.appendChild(s);
    }
  }, []);

  const checkPromo = async () => {
    const response = await fetch('/signupcheckpromo', {
      method: "POST",
      headers: {"Content-Type": "application/json", "X-CSRFToken": token},
      body: JSON.stringify({credit_code: values.credit_code, update_code: updateCode})
    });
    const data = await response.json();
    if (data.ok) {
      setCreditCodeError('');
      let message = 'Your code has been accepted';
      if (data.amount) {
          message += ' $' + data.amount + ' will be added to your account.';
      }
      setCreditCodeSuccess(message);
    } else {
      setCreditCodeError(data.error);
    }
  };

  const updateCustomer = async (stripeToken) => {
    setValues(inputs => ({...inputs, stripeToken: stripeToken}));
    values['stripeToken'] = stripeToken;
    const response = await fetch('/customersignup', {
      method: "POST",
      headers: {"Content-Type": "application/json", "X-CSRFToken": token},
      body: JSON.stringify(values) // {values: values})
    });//.then(response => {
    //  console.log('returned');
    //  console.log(response.json().then(data => console.log(data)));
    //});
    const data = await response.json();
    if (data.ok) {
        if (data.order) {
          navigate('/thankyouorder');
        } else {
          navigate('/thankyou');
        }
    }
    if (data.errors) {
        setErrors(data.errors);
    }
    if (data.errorMessage) {
        setErrorMessage(data.errorMessage)
    }
    //setValues(data.values);

  }

  useEffect(() => {
    if (searchParams.get('code')) {
      fetch('/csrf', {
      }).then(response => {
          setToken(response.headers.get('X-CSRFToken'));
      });
      setUpdateCode(searchParams.get('code'));
      setValues(inputs => ({...inputs, update_code: searchParams.get('code')}));
      fetch(`/getcustomerforsignup?code=${searchParams.get('code')}`, {
      }).then(response => {
        response.json().then(data => {
          //console.log(data));
          if (data.ok) {
            if (data.alreadyDone) {
              navigate('/thankyoualreadydone');
            } else {
              //if (data.hasCreditCode) {
              //    setCreditCodeClasses(['approvalCreditRow',  'approvalCreditRowHidden']);
              //}
              setValues(inputs => ({...inputs, phone: data.phone, email: data.email}));
            }
          } else {
            //console.log('no customer found');
            navigate('/');
          }
        });
      });
    } else {
        navigate('/');
    }

  }, []);

  return (
    <div>
      <div className="signupNavBar" >
        <img alt="Drops" className="signupNavBarImage" src="/images/landing/Illustrations/Various_Illustrations/DROPS_LOGO_10_21.svg" />
      </div>
      <div className="approvalSignUpSection" >

    <div className="approvalContentInner" >
        <form id="approvalForm" onSubmit={onSubmit} autocomplete="off" method="POST">
            <div className="approvalInnerForm">
                <div className="approvalMainForm" >
                    <div className="approvalTitleSection">
                        <div className="approvalTitle1">
                        &#9749; You're on our list.
                        </div>
                        <div className="approvalTitle2">
                        Our Drops go fast. Complete your profile so you can text to order coffee at the opportune moment.
                        </div>
                        <div className="approvalTitle3">
                        Reminder: it's free to be on our list, you only pay for what you order.
                        </div>
                    </div>


                    <div className={addressSectionClasses.join(' ')}>
                        <div className="approvalInfoHeaderRow" >
                            <div className="approvalInfoHeader" >
                            <h4>Your info</h4>
                            </div>
                        </div>
                        <div className="approvalInfoNameRow" >
                            <div className={"approvalFirstNameDiv " + (errors.first_name ? 'inputError' : '')} >
                                <div id="approvalFirstNameLabel" className={"approvalFirstNameLabel " + (values.first_name ? 'inputShow' : '')} >
                                First name
                                </div>
                                <input id="approvalFirstNameEntry" className={"approvalFirstNameEntry " + (values.first_name ? 'inputEntered' : '')} type="text" value={values.first_name} onChange={handleChange} name="first_name" placeholder="First Name"/>
                            </div>
                            <div className={"approvalLastNameDiv " + (errors.last_name ? 'inputError' : '')} >
                                <div id="approvalLastNameLabel" className={"approvalLastNameLabel " + (values.last_name ? 'inputShow' : '')} >
                                Last name
                                </div>
                                <input id="approvalLastNameEntry" className={"approvalLastNameEntry " + (values.last_name ? 'inputEntered' : '')} type="text" value={values.last_name} onChange={handleChange} name="last_name" placeholder="Last Name"/>
                            </div>
                        </div>
                        <div className="approvalPhoneRow" >
                            <div className={"approvalPhoneDiv " + (errors.phone ? 'inputError' : '')} >
                                <div id="approvalPhoneLabel" className={"approvalPhoneLabel " + (values.phone ? 'inputShow' : '')} >
                                Phone
                                </div>
                                <input id="approvalPhoneEntry" className={"approvalPhoneEntry " + (values.phone ? 'inputEntered' : '')} type="text" value={values.phone} onChange={handleChange} name="phone"  placeholder="Phone number"/>
                                <div className="invalidCustomer" id="invalidCustomer"></div>
                            </div>
                            <div className={"approvalEmailDiv " + (errors.email ? 'inputError' : '')} >
                                <div id="approvalEmailLabel" className={"approvalEmailLabel " + (values.email ? 'inputShow' : '')} >
                                Email
                                </div>
                                <input id="approvalEmailEntry" className={"approvalEmailEntry " + (values.email ? 'inputEntered' : '')} type="text" name="email" value={values.email} onChange={handleChange} placeholder="Email"/>
                            </div>
                        </div>

                        <div className="approvalAddressRow" >
                            <div className={"approvalAddressDiv " + (errors.address1 ? 'inputError' : '')} >
                                <div id="approvalAddressLabel" className="approvalAddressLabel" >
                                Address
                                </div>
                                <input id="address1" name="address1" className="approvalAddressEntry" type="search" value={values.address1} ref={address1Ref} onChange={handleChange} placeholder="Address" autocomplete="none" aria-autocomplete="list" role="combobox" aria-multiline="false" aria-expanded={autocompleteExpanded} aria-controls="autocompleteList"/>
                                <AddressAutoComplete setAddress={setAddress} fieldRef={address1Ref} setAutocompleteVisible={setAutocompleteVisible}/>

                            </div>
                                <div className="invalidAddress" id="invalidAddress"></div>
                        </div>
                        <div className="approvalAddress2Row" >
                            <div className="approvalAddress2Div" >
                                <div id="approvalAddress2Label" className="approvalAddress2Label" >
                                Apartment, suite, etc (optional)
                                </div>
                                <input id="approvalAddress2Entry" className="approvalAddress2Entry" type="text" name="address2" value={values.address2} onChange={handleChange} placeholder="Apartment, suite, etc (optional)"/>
                            </div>
                        </div>

                        <div className="approvalCityRow" >
                            <div className={"approvalCityDiv " + (errors.city ? 'inputError' : '')} >
                                <div id="approvalCityLabel" className="approvalCityLabel" >
                                City
                                </div>
                                <input id="approvalCityEntry" className="approvalCityEntry" type="search" name="city" value={values.city} onChange={handleChange} placeholder="City" autocomplete="none"/>
                            </div>
                            <div className={"approvalStateDiv " + (errors.state ? 'inputError' : '')} >
                                <div id="approvalStateLabel" className="approvalStateLabel" >
                                State
                                </div>
                                <input id="approvalStateEntry" className="approvalStateEntry" type="search" name="state" value={values.state} onChange={handleChange} placeholder="State" autocomplete="none"/>
                            </div>
                        </div>

                        <div className="approvalCountryRow" >
                            <div className={"approvalZipcodeDiv " + (errors.zipcode ? 'inputError' : '')} >
                                <div id="approvalZipcodeLabel" className="approvalZipcodeLabel" >
                                Zipcode
                                </div>
                                <input id="approvalZipcodeEntry" className="approvalZipcodeEntry" type="search" name="zipcode" value={values.zipcode} onChange={handleChange} placeholder="Zipcode" autocomplete="none"/>
                            </div>
                            <div className="approvalCountryDiv" >
                                <input className="approvalCityEntry" placeholder="United States" readOnly={true}/>
                            </div>
                        </div>
                        <div className="approvalAddressSubtextRow" >
                        *Your address must be in the U.S. and be able to receive USPS, UPS, and FedEx packages.
                        </div>

                        <div className="approvalReferralLine">
                        </div>

                        <div className="approvalReferralMaintextRow">
                        Referral or Promotional Code (optional)
                          <div className="referralCodeArrowSection" onClick={() => referralDownClick()}>
                            <img alt="Down Arrow" className={downArrowClass} src="images/landing/Illustrations/Various_Illustrations/small_arrow_r.png" />
                          </div>

                        </div>

                        <div className={creditCodeClasses.join(' ')}>
                          <div className="approvalCreditRow">
                            <div className="approvalCreditDiv" >
                                <div id="approvalCreditLabel" className="approvalCreditLabel" >
                                Promo Code (optional)
                                </div>
                                <input id="approvalCreditEntry" className="approvalCreditEntry" type="search" value={values.credit_code} onChange={handleChange} name="credit_code" autocomplete="none"/>
                            </div>
                            <div id="approvalCreditEntryApply" className="approvalCreditEntryApply" onClick={() => {checkPromo()}}>Apply</div>
                          </div>

                          <div className="approvalReferralSubtextRow" >
                          *To attribute your signup to a friend, tell them to text 'refer friends' to Fellow Drops to get their code.
                          </div>

                        </div>

                        { creditCodeError && <div id="creditCodeError" style={{color: '#ff694a', fontFamily: 'Inter', paddingTop: '10px', fontSize: '13.333px', fontWeight: '700'}}>{creditCodeError}</div> }
                        { creditCodeSuccess && <div id="creditCodeSuccess" style={{color: '#5f9b8f', fontFamily: 'Inter', paddingTop: '10px', fontSize: '13.333px', fontWeight: '700'}}>{creditCodeSuccess}</div> }

                        { errors.credit_code && <div style={{color: 'red', paddingTop: '10px', fontSize: '13.333px'}}>Enter a valid discount code.</div> }

                        <div className="approvalReferralBottomLine">
                        </div>

                        <div className="nextSection">
                            <div className="approvalSubmitButton" id="signUpSubmit" onClick={nextClick} >
                                <div className="approvalSubmitButtonText" >NEXT</div>
                            </div>
                        </div>
                    </div>

                    <div className={creditSectionClasses.join(' ')}>
                        <CreditCard returnToInformation={returnToInformation} updateCustomer={updateCustomer}/>
                    </div>

                </div>

                { errorMessage &&
                    <div className="errorMessage">{errorMessage}</div>
                }
                {/*
                <div className="footerQuestions">
                *Still have questions? Visit our <a href="/faq">FAQ</a>
                </div>
                */}
            </div>
        </form>
    </div>


      </div>
    </div>  
  );
}

